<script>
	export let params

	import { getContext } from 'svelte'
	const ticketPlugin = getContext("ticketPlugin") 
	const firebaseUser = getContext("firebaseUser")
	const userRole = getContext("userRole")

	import MainContainer from "./MainContainer.svelte"
	import Preloader from './Preloader.svelte'

    import firebase from "firebase/app"
    import "firebase/firestore"

	// const dummyTicket = {
	// 	header: "Ticket header",
	// 	body: "Ticket body",
	// 	creationTime: firebase.firestore.Timestamp.fromDate(new Date()),
	// 	modificationTime: firebase.firestore.Timestamp.fromDate(new Date()),
	// 	important: true,
	// 	needReplyFromAdmin: true,
	// 	userId: "__UserID__",

	// 	messages: [
	// 		{adminId: "__AdminID__", text: "Hi! Dont worry, be happy!", time: firebase.firestore.Timestamp.fromDate(new Date())},
	// 		{text: "WTF?!", time: firebase.firestore.Timestamp.fromDate(new Date())},
	// 	]
	// }

	let ticket// = dummyTicket
    let userId
    let platform
	
	const ticketDoc = firebase.firestore().collection("HelpDeskTickets").doc(params.id)

	async function getTicket() {
		let snapshot = await ticketDoc.get()
		if (snapshot.exists) {
			ticket = {...snapshot.data(), id: snapshot.id}
		} 
		return snapshot
	}
	let ticketDocPromise = getTicket()

	ticketDoc.onSnapshot(snapshot => {
		//console.log(`Received doc snapshot: ${JSON.stringify(snapshot.data())}`)
        ticket = {...snapshot.data(), id: snapshot.id}
        userId = snapshot.data().userId
	}, err => {
		console.log(`Encountered error: ${err}`)
	})

    $: if (userId) {
        //console.log(`UserId changed: ${userId}`)
        getPlatform()
    }
   
    async function getPlatform() {
        const snapshot = await firebase.firestore().collection("UserData").doc(userId).get()
         if (snapshot.exists) {
            platform = snapshot.data().platform
        }
        return snapshot
    }

	let replyMessage = ""
	let editMessageIndex = -1
	let ticketPluginInstance

    function sendReplyMessage() {
		replyMessage = replyMessage.trim()
		if (!replyMessage) {
			editMessageIndex = -1
			return
		}

		const msg = {
            adminId: firebaseUser.uid, 
			text: replyMessage, 
			time: firebase.firestore.Timestamp.fromDate(new Date())
        }
		const awardParams = ticketPluginInstance ? ticketPluginInstance.getParams() : undefined
		if (awardParams) {
			msg.parameter = awardParams
		}

		if (!ticket.messages) {
			ticket.messages = []
		}
		if (editMessageIndex == -1) {
			ticket.messages.push(msg)
		} else {
			ticket.messages[editMessageIndex] = msg
		}
		ticket.modificationTime = firebase.firestore.Timestamp.fromDate(new Date())
		ticketDoc.update({messages: ticket.messages, modificationTime: ticket.modificationTime, needReplyFromAdmin: false, newMessageFromAdmin: true})

		const adminName = firebaseUser.displayName || firebaseUser.email || "Anonymous"		
		firebase.firestore().collection("AdminActionLog").add({
			adminId: firebaseUser.uid,
			ticketId: params.id,
			time: firebase.firestore.Timestamp.fromDate(new Date()),
			type: editMessageIndex == -1 ? "HelpDeskTicketReply" : "HelpDeskTicketReplyEdit",
			text: `${adminName} ${editMessageIndex == -1 ? "replied to" : "edited reply in"} ticket <a href="/#/Ticket/${ticket.id}">${ticket.header}</a>`
		})

		cancelEditor()
	}

	function editMessage(index) {
		editMessageIndex = index
		replyMessage = ticket.messages[editMessageIndex].text
		document.getElementById("message_reply").focus()
		if (ticketPluginInstance) {
			ticketPluginInstance.assignParams(ticket.messages[editMessageIndex].parameter)
		}
	}

	function cancelEditor() {
		replyMessage = ""
		editMessageIndex = -1
		if (ticketPluginInstance) {
			ticketPluginInstance.resetParams()
		}
	}

	import {afterUpdate} from 'svelte';
	afterUpdate(async () => {
		M.Collapsible.init(document.querySelectorAll('.collapsible'))
	})
</script>


<MainContainer>
	{#await ticketDocPromise}
		<Preloader text="Obtaining ticket..." />
	{:then}
		{#if ticket}
			<h5 class="blue-text"><i class="material-icons left">label_important</i>{ticket.header}</h5>
			<div class="ticket-time">
				{#if ticket.important}<i class="material-icons tiny red-text">warning</i>{/if}
				{ticket.creationTime.toDate().toLocaleString()} {#if platform} ({platform}) {/if}
				<a href="/#/User/{ticket.userId}" class="right">User</a>
			</div>

			<div class="ticket-body">
                {ticket.body}
            </div>

			{#if ticket.parameter}
				<ul class="collapsible">
					<li>
					<div class="collapsible-header"><i class="material-icons">attachment</i>Parameter...</div>
					<div class="collapsible-body"><span>{JSON.stringify(ticket.parameter)}</span></div>
					</li>
				</ul>
			{/if}
			  
			<div class="ticket-messages">
				{#each ticket.messages || [] as msg, index}
					{#if msg.adminId && userRole == "Writer"}
						<button class="btn-floating left btn-small" title="Edit message" on:click={() => editMessage(index)}><i class="material-icons">edit</i></button>
					{/if}
					<div class="{msg.adminId ? 'ticket-message-admin' : 'ticket-message-user'}">
						<p class="ticket-message-text">{msg.text}</p>
						{#if msg.parameter}
							<span class="left msg-parameter teal lighten-2" title="{JSON.stringify(msg.parameter)}">{'{p}'}</span>
						{/if}
						<p class="ticket-message-time">{msg.time.toDate().toLocaleString()}</p>
					</div>
				{/each}
			</div>

			{#if userRole == "Writer"}
				<svelte:component this={ticketPlugin} bind:this={ticketPluginInstance}/>

				<div class="input-field reply-input-field">
					<i class="material-icons prefix">mode_edit</i>
					<textarea id="message_reply" class="materialize-textarea" bind:value={replyMessage} ></textarea>
					<label for="message_reply">
						{#if editMessageIndex == -1}
							Reply:
						{:else}
							Edit reply #{editMessageIndex + 1}:
						{/if}
					</label>
				</div>
				<div class="row" id="reply-buttons">
					<button class="btn waves-effect waves-light right" type="submit" disabled={replyMessage === ""} on:click={sendReplyMessage}>
                        <i class="material-icons right">send</i>Send
                    </button>
					<button class="btn-flat waves-effect waves-light right" on:click={cancelEditor}>
                        <i class="material-icons right">cancel</i>Cancel
                    </button>
				</div>
			{/if}

		{:else}
			<p class="red-text"><i class="material-icons left">warning</i> Ticket "{params.id}" not found!</p>
		{/if}
	
	{:catch error}
		<p class="red-text"><i class="material-icons left">warning</i> Error: {error.message}</p>
	{/await}		
</MainContainer>


<style>
	.ticket-time {
		font-size: 0.9em;
		font-style: italic;
	}
	.ticket-time i {
		margin-right: 3px;
		position: relative;
		top: 3px;
	}
	.ticket-time a {
		font-style: normal;
	}
	.ticket-body {
		margin: 20px 0;
		white-space: pre-wrap;
	}
	.ticket-message-user, .ticket-message-admin {
		padding: 5px 25px 2px 25px;
		margin: 20px 0;
		border-radius: 10px;
	}
	.ticket-message-admin {
		margin-left: 50px;
		background-color: #f0f4ff;
	}
	.ticket-message-user {
		background-color: #f0f0f0;
		margin-right: 50px;
	}
	.ticket-message-text {
		white-space: pre-wrap;
		margin-block-end: 0.5em;
	}
	.ticket-message-time {
		font-size: 0.85em;
		font-style: italic;
		text-align: right;
		padding-bottom: 2px;
		color: grey;
		margin-block-start: 0.5em;
		margin-block-end: 0.1em;
	}
	.msg-parameter {
		font-size: 0.75em;
		color: white;
		padding: 1px 3px;
		border-radius: 3px;
	}
	.reply-input-field {
		margin-top: 40px;
		margin-left: 15px;
	}
	#reply-buttons button {
		margin-left: 15px;
		margin-right: 10px;
	}
	.collapsible {
		box-shadow: none;
		border-top: none;
		border-left: none;
		border-right: none;
	}
	.collapsible-header {
		font-style: italic;
	}
	.collapsible-body {
		border-bottom: none;
	}
</style>